import Vue from 'vue';
import Router from 'vue-router';

import AuthenticationService from './common/services/authentication.service';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/users/login',
      name: 'Login',
      component: () => import('@/views/users/Login.vue'),
    },
    {
      path: '/',
      component: () => import('@/views/templates/main.vue'),
      children: [
        {
          path: '/',
          name: 'MainIndex',
          component: () => import('@/views/Dashboard.vue'),
        },

        // Users
        {
          path: '/users',
          name: 'UsersIndex',
          component: () => import('@/views/users/index'),
        },
        {
          path: '/users/new',
          name: 'UserNew',
          component: () => import('@/views/users/new'),
        },
        {
          path: '/users/:id/edit',
          props: true,
          name: 'UserEdit',
          component: () => import('@/views/users/edit'),
        },
        {
          path: '/users/:id',
          props: true,
          name: 'UserShow',
          component: () => import('@/views/users/show'),
        },

        // Movies
        {
          path: '/movies',
          name: 'MoviesIndex',
          component: () => import('@/views/movies/index'),
        },
        {
          path: '/movies/new',
          name: 'MovieNew',
          component: () => import('@/views/movies/new'),
        },
        {
          path: '/movies/:id/edit',
          props: true,
          name: 'MovieEdit',
          component: () => import('@/views/movies/edit'),
        },
        {
          path: '/movies/:id',
          props: true,
          name: 'MovieShow',
          component: () => import('@/views/movies/show'),
        },

        // Music
        {
          path: '/muisc',
          name: 'MusicIndex',
          component: () => import('@/views/music/index'),
        },
        {
          path: '/muisc/new',
          name: 'MusicNew',
          component: () => import('@/views/music/new'),
        },
        {
          path: '/muisc/:id/edit',
          props: true,
          name: 'MusicEdit',
          component: () => import('@/views/music/edit'),
        },
        {
          path: '/muisc/:id',
          props: true,
          name: 'MusicShow',
          component: () => import('@/views/music/show'),
        },

        // Shows
        {
          path: '/shows',
          name: 'ShowIndex',
          component: () => import('@/views/shows/index'),
        },
        {
          path: '/shows/new',
          name: 'ShowNew',
          component: () => import('@/views/shows/new'),
        },
        {
          path: '/shows/:id/edit',
          props: true,
          name: 'ShowEdit',
          component: () => import('@/views/shows/edit'),
        },
        {
          path: '/shows/:id',
          props: true,
          name: 'ShowShow',
          component: () => import('@/views/shows/show'),
        },

        // Organizations
        {
          path: '/organizations',
          name: 'OrganizationsIndex',
          component: () => import('@/views/organizations/index'),
        },
        {
          path: '/organizations/new',
          name: 'OrganizationNew',
          component: () => import('@/views/organizations/new'),
        },
        {
          path: '/organizations/:id/edit',
          props: true,
          name: 'OrganizationEdit',
          component: () => import('@/views/organizations/edit'),
        },
        {
          path: '/organizations/:id',
          props: true,
          name: 'OrganizationShow',
          component: () => import('@/views/organizations/show'),
        },
      ],
    }
  ],
});

router.beforeEach(AuthenticationService.checkAuthentication);

export default router;
